import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withStyles } from "@mui/styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Card,
  Grid
} from "@mui/material";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent";
import { fetchTransferHistory } from ".";
import TransferHistory from "../../components/TransferHistoryComponent/TransferHistory";
import { fetchFile } from ".";
import openFile from "../../components/shared/functions/download";

const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
  }
});

function TransferHistoryPage({ accessToken, client, location, classes }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const {showErrorMessage, showSuccessMessage, hideMessage} = useMessage();
  const [history, setHistory] = useState({
    allKeys: [],
    byKey: {}
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    fetchTransferHistory(client, accessToken)
    .then((history)=>{
      setHistory(history)
    })
    .catch((err)=> {
      showErrorMessage(err)
    })
    .finally(() => {
      setIsLoading(false);
    })

    // eslint-disable-next-line
  }, []);

  const handleBelegClicked = (beleg) => {
    setIsLoading(true);

    fetchFile(client, accessToken, beleg.key, beleg.betreff+'_'+beleg.key+beleg.dateiart)
    .then((file)=>{
      openFile(file.name, file.content, file.type);
    })
    .catch((err)=> {
      showErrorMessage(err)
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  if (isLoading) {
    return <LoadingComponent path={location} />;
  } else {
    return (
      <div>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Card className={classes.paper}>
              <TransferHistory history={history} onBelegClicked={handleBelegClicked} />
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}

TransferHistoryPage.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(TransferHistoryPage);